import React from 'react';
import './EmergencyService.css';
import { Link } from 'react-router-dom';

const EmergencyService = () => {
  return (
    <div className="emergency-section">
      <div className="overlay">
        <h2 className="emergency-title">Need an Emergency Design Service?</h2>
        <p className="emergency-description">We are available 24/7 to help you with urgent design and printing needs. Contact us for immediate assistance and get your project done fast and efficiently.</p>

        <div className="hero-btn-box">
        <Link to="tel:+234-802-387-9629" >
          <button className="hero-btn-btn our-service">+234 802 387 9629</button>
        </Link>
        <Link to="https://wa.me/2348023879629" >
          <button className="hero-btn-btn discover">Request a Quote</button>
        </Link>
       </div>
      </div>
    </div>
  );
};

export default EmergencyService;
